import * as actionTypes from "../constants/actionTypes";
import * as modelHelper from "../helpers/modelHelper";

const initialState = {
    barcode: "",
    manualScan: false,
    itemType: null,
    item: null,
    barcodeData: null
};

/**
 * Structure of barcode store:
 * - barcode {String}                       - last result from barcode scanner
 * - manualScan {Boolean}                   - if true, modal with barcode input is active
 * - itemType {Number | null}               - type of barcode item
 * - item {Object | null}                   - assigned item to barcode
 * - barcodeData {Object | null}            - detailed barcode info
 */
export const barcodeReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SAVE_BARCODE:
            return {
                ...state,
                barcode: action.payload.barcode
            };
        case actionTypes.SHOW_MANUAL_SCAN:
            return {
                ...state,
                manualScan: action.payload.manualScan
            };
        case actionTypes.SAVE_BARCODE_ITEM:
            return {
                ...state,
                itemType: action.payload.itemType,
                item: action.payload.item
            };
        case actionTypes.SAVE_BARCODE_DATA:
            return {
                ...state,
                barcodeData: modelHelper.mapBarcodeDataToObject(action.payload.data)
            };
        case actionTypes.RESET_BARCODE_DATA:
            return {
                ...state,
                barcodeData: null
            };
        case actionTypes.DATABASE_CHANGE:
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.BARCODE_RESET:
            return initialState;
        default:
            return state;
    }
};
